export const dark = "rgba(46, 56, 66, 0)"
export const red = "rgba(255, 82, 82, 1)"
export const text = "rgba(255, 255, 255, 1)"
export const blue = "rgba(65, 115, 186, 1)"
export const darker = "rgba(46, 56, 66, 0)"
export const gray = "rgba(15, 52, 96, 0.8)"